import styled from "styled-components";
import noiseImage from './noise.svg'

type Props = {
    $active?: boolean
    $showMobile?: boolean,
    $showDesktop?: boolean,
    $responsive?: boolean
}

export default styled.div<Props>`
    ${({ $showDesktop = true }) => $showDesktop ? `
        display: block;
    ` : `
        display: none;
    `}
    list-style: none;
    padding: 0;
    margin: 0;
    opacity: 0.95;

    & a {
        text-decoration: none;
        color: #302418;
        font-weight: bold;
        padding: 0.5rem 3rem 0.5rem 2rem;
        margin: 0.25rem -2rem;
        display: inline-block;
        text-underline-offset: 0.4rem;

        ${({ $active = false }) => $active && `
            text-decoration: underline;
            text-decoration-thickness: 0.25em;
        `}

        &:hover {
            color: #e6a302;
            background: linear-gradient(-91.25deg, #191006ee 0%, #000000dd 100%) ,url(${noiseImage});
            clip-path: polygon(0 0, 98% 0%, 100% 150%, 2% 150%);
            text-shadow: -0.5rem -0.05em 0 #191006,  0 0.3rem 0 #191006, 0 -0.3rem 0 #191006, -0.3rem 0.3rem 0 #191006;
            text-decoration: underline;
            text-decoration-thickness: 0.2em;

            & svg {
                fill: #e6a302;
            }

        }
    }

    & svg {
        fill: #302418;
    }
    ${({ $responsive = true, $showMobile = true }) => $responsive && `
        @media screen and (max-width: 1260px) {
            & a {
                display: block;
                padding: 1rem 1rem;
                margin: 0.25rem 1rem;
            }
        }

        @media screen and (max-width: 920px) {
            ${$showMobile ? `
                display: block;
            ` : `
                display: none;
            `}
        }

        @media screen and  (max-width: 740px) {

        }
    
        @media screen and (max-width: 390px) {

        }
    `}
`